module.exports = __webpack_public_path__ + "img/banner-safari.a6b16a6f.jpeg";